export default "__VITE_ASSET__3jVnziet__"